"use client"

import { useViewer } from "@/platform/session/use-viewer"
import { ANONYMOUS_VIEWER } from "@/platform/session/viewer"

export const useAuthenticatedViewer = (): string | null => {
  const viewer = useViewer()
  return viewer === ANONYMOUS_VIEWER ? null : viewer
}
